import { SystemEntity } from '@erp/shared-types';
import { Badge } from '@/components/ui/badge';
import {
  HoverCard,
  HoverCardTrigger,
  HoverCardContent,
} from '@/components/ui/hover-card';
import { cn } from '@/lib/utils';
import { EnvelopeSimpleIcon } from '@phosphor-icons/react';
import { T } from 'gt-react';
import { SystemEntityPreview } from '../preview-ui';

interface InboundEmailInlineProps {
  entityType: SystemEntity;
  entityId: string;
  className?: string;
}

export function InboundEmailInline({
  entityId,
  className,
}: InboundEmailInlineProps) {
  return (
    <HoverCard openDelay={200} closeDelay={100}>
      <HoverCardTrigger asChild>
        <div className="inline-block max-w-full">
          <Badge
            variant="outline"
            className={cn('gap-1.5 cursor-pointer max-w-full', className)}
          >
            <EnvelopeSimpleIcon className="size-3 shrink-0" />
            <span className="truncate">
              <T context="system entity type label">Email</T>
            </span>
          </Badge>
        </div>
      </HoverCardTrigger>
      <HoverCardContent
        className="w-auto p-0 pointer-events-auto"
        align="start"
        side="bottom"
        sideOffset={2}
        onPointerEnter={(e) => e.stopPropagation()}
        onPointerLeave={(e) => e.stopPropagation()}
      >
        <SystemEntityPreview
          entityType={SystemEntity.INBOUND_EMAIL}
          entityId={entityId}
        />
      </HoverCardContent>
    </HoverCard>
  );
}
